/**
 * Canonical long-wait rule for RESTART_PLAYER commands: a command still
 * 'pending' or 'sent' this long after being sent (or created, if never
 * sent) is flagged as long-waiting.
 *
 * Single source of truth, consumed two ways (cannot be literally shared
 * code across runtimes):
 *  - Frontend (DeviceCommandStatus.tsx) imports these directly to drive
 *    the live per-command caveat.
 *  - apps/api imports these and passes them as bound SQL parameters into
 *    the command-operations repository query (packages/database has no
 *    dependency on this package, so the values travel as plain
 *    arguments, never as SQL text).
 * Changing either value here is the only change needed; both consumers
 * pick it up automatically. Do not hardcode 90 or 'RESTART_PLAYER'
 * anywhere else.
 */
export const LONG_WAIT_COMMAND_TYPE = 'RESTART_PLAYER';
export const LONG_WAIT_THRESHOLD_SECONDS = 90;
/**
 * Maps operator-enqueueable commands to the capability token a player must
 * report before the dashboard offers that action (ADR 0006).
 */
export const OPERATOR_COMMAND_CAPABILITY = {
    SYNC_NOW: 'cmd_sync_now',
    CLEAR_CACHE: 'cmd_clear_cache',
    RESTART_PLAYER: 'cmd_restart_player',
};
/** Stable UI / fleet order for V1 operator commands. */
export const OPERATOR_COMMAND_ORDER = [
    'SYNC_NOW',
    'CLEAR_CACHE',
    'RESTART_PLAYER',
];
/**
 * Which remote actions to show for a device.
 * - `null` / `undefined` capabilities → unknown (legacy Android): show all V1 operator commands.
 * - non-null array → only commands whose capability token is present (may be empty).
 */
export function visibleOperatorCommands(capabilities) {
    if (capabilities == null)
        return [...OPERATOR_COMMAND_ORDER];
    return OPERATOR_COMMAND_ORDER.filter((type) => capabilities.includes(OPERATOR_COMMAND_CAPABILITY[type]));
}
//# sourceMappingURL=operator-commands.js.map